import * as types from '../constants/actionTypes';

export function createAttribute({attribute, status, data} = {}) {
    return {
        type: types.CREATE_ATTRIBUTE
        , attribute
        , status
        , data
    };
}
export function deletAttribute({attributeID, status, data} = {}) {
    return {
        type: types.DELETE_ATTRIBUTE
        , attributeID
        , status
        , data
    };
}
export function loadAllAttributes({status, data} = {}) {
    return {
        type: types.LOAD_ALL_ATTRIBUTES
        , status
        , data
    };
}
export function loadDefaultAttributes({status, data} = {}) {
    return {
        type: types.LOAD_DEFAULT_ATTRIBUTES
        , status
        , data
    };
}
export function projectSetAttributeValue({projectID, attributeValue, status, data} = {}) {
    return {
        type: types.PROJECT_SET_ATTRIBUTE_VALUE
        , projectID
        , attributeValue
        , status
        , data
    };
}
export function projectSetAttributeValues({projectID, attributeValues, status, data} = {}) {
    return {
        type: types.PROJECT_SET_ATTRIBUTE_VALUES
        , projectID
        , attributeValues
        , status
        , data
    };
}


/** WEBPACK FOOTER **
 ** ./src/app/constants/attributeActions.js
 **/